// © Microsoft Corporation. All rights reserved.

import { DarkModeBackgroundColor, LightModeBackgroundColor } from "@msnews/experiences-base";
import { DesignSystem, isDarkMode, neutralFillSelected, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { enums } from "../../../../utils/enums";

export const ProfileUsersSuperAppStyles = (config: DesignSystem) => ({
    profileUsersSuperAppContainer: {
        background: isDarkMode(config) ? DarkModeBackgroundColor : LightModeBackgroundColor,
        "border-radius": "20px",
        display: "flex",
        "flex-direction": "column",
        "align-items": "center",
        "padding-bottom": "50px",
        "& .cwt-profile-user": {
            background: neutralLayerCard,
            padding: "16px 19px",
            "max-width": "75vw",
            width: "75vw",
            border: "none",
            "border-radius": "6px",
            "box-shadow": "0px 0px 0.8px rgba(0, 0, 0, 0.13), 0px 2px 10px rgba(0, 0, 0, 0.08)",

            "margin-top": "16px",
            "& .cwt-avatar": {
                margin: "0"
            },

            "& .cwt-user-info": {

                "& .cwt-name": {
                    "font-size": "15px",
                    "font-weight": "normal"
                },
                "& .cwt-stat": {
                    "font-size": "12px",
                    "margin-top": "8px"
                }
            }
        },
        ["&." + enums.responsiveLevels.L0]: {
            display: "block",
            background: isDarkMode(config) ? "#181818" : "#FFFFFF",
            "& .cwt-profile-user": {
                "border-bottom": "1px solid",
                "border-color": neutralFillSelected,
                background: "none",
                "margin-top": "0",
                "max-width": "100%",
                width: "auto",
                "box-shadow": "none",
                "border-radius": "0"
            }
        }
    },
    profileEmptyMessageSuperAppContainer: {
    }
});